import React from 'react';
import { Game } from './game/Game';

export default function ExpandedView() {
    return (
        <Game />
    );
}